import React, { createContext, useContext, useState, useEffect } from 'react';

const ViewContext = createContext();

export const useView = () => {
    const context = useContext(ViewContext);
    if (!context) {
        throw new Error('useView must be used within a ViewProvider');
    }
    return context;
};

export const ViewProvider = ({ children }) => {
    const [viewMode, setViewMode] = useState(() => {
        const saved = localStorage.getItem('wiki-view-mode');
        return saved || 'grid';
    });

    useEffect(() => {
        localStorage.setItem('wiki-view-mode', viewMode);
    }, [viewMode]);

    const toggleView = () => {
        setViewMode(prev => prev === 'grid' ? 'list' : 'grid');
    };

    const isGrid = viewMode === 'grid';

    return (
        <ViewContext.Provider value={{ viewMode, setViewMode, toggleView, isGrid }}>
            {children}
        </ViewContext.Provider>
    );
};
